<template>
	<span ref="el" class="strong-text" :class="{ small: size === 'small' }">
		<span class="bg" />
		<span class="text">
			<slot />
		</span>
	</span>
</template>

<script setup>
import { gsap, ScrollTrigger } from 'gsap/all'

const props = defineProps({
	value: { type: [String, Array], default: undefined },
})

const context = inject('pageContext')
const size = inject('highlightedTextSize', '')

const el = ref(null)
let scrollTrigger = null

const setup = () => {
	const bg = el.value.querySelector('.bg')

	gsap.set(bg, {
		clipPath: 'inset(0 100% 0 0)',
	})

	scrollTrigger = ScrollTrigger.create({
		trigger: el.value,
		start: 'top 90%',
		onEnter: () => {
			gsap.to(bg, {
				clipPath: 'inset(0 0% 0 0)',
				duration: 0.7,
				ease: 'power4.inOut',
			})
		},
		onEnterBack: () => {
			gsap.to(bg, {
				clipPath: 'inset(0 100% 0 0)',
				duration: 1.0,
				ease: 'power4.inOut',
			})
		},
		once: true,
	})
}

const init = () => {}

const kill = () => {
	scrollTrigger?.kill()
}

onBeforeUnmount(() => {
	kill()
})
onMounted(() => {
	context.$page.loader.ready.then(() => setup())
})
</script>

<style lang="scss" scoped>
.strong-text {
	position: relative;
	color: var(--color-geral-creme);
}

.bg {
	position: absolute;

	width: 100%;
	height: 100%;

	background-color: var(--color-geral-creme);
	z-index: -1;

	border-radius: rs(12, 4);

	.small & {
		border-radius: rs(4, 2);
	}
}

.text {
	position: relative;
	padding-top: rs(5, 5);
	padding-bottom: 0;
	padding-left: rs(6, 6);
	padding-right: rs(18, 12);

	mix-blend-mode: difference;

	z-index: 1;

	.small & {
		padding-top: rs(2, 2);
		padding-bottom: 0;
		padding-left: rs(5, 5);
		padding-right: rs(8, 6);
	}
}
</style>
